"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceDataset = void 0;
const interfaces_1 = require("@build-5/interfaces");
const rxjs_1 = require("rxjs");
const Dataset_1 = require("../Dataset");
class SpaceDataset extends Dataset_1.DatasetClass {
    constructor() {
        super(...arguments);
        this.create = (this.sendRequest(interfaces_1.WEN_FUNC.createSpace));
        this.update = (this.sendRequest(interfaces_1.WEN_FUNC.updateSpace));
        this.join = (this.sendRequest(interfaces_1.WEN_FUNC.joinSpace));
        this.leave = (this.sendRequest(interfaces_1.WEN_FUNC.leaveSpace));
        this.blockMember = (this.sendRequest(interfaces_1.WEN_FUNC.blockMemberSpace));
        this.unblockMember = (this.sendRequest(interfaces_1.WEN_FUNC.unblockMemberSpace));
        this.acceptMember = (this.sendRequest(interfaces_1.WEN_FUNC.acceptMemberSpace));
        this.declineMember = (this.sendRequest(interfaces_1.WEN_FUNC.declineMemberSpace));
        this.addGuardian = (this.sendRequest(interfaces_1.WEN_FUNC.addGuardianSpace));
        this.removeGuardian = (this.sendRequest(interfaces_1.WEN_FUNC.removeGuardianSpace));
        this.claim = (this.sendRequest(interfaces_1.WEN_FUNC.claimSpace));
        this.validateAddress = (this.sendRequest(interfaces_1.WEN_FUNC.validateAddress));
        this.getTopByMember = (member, orderBy = ['createdOn'], orderByDir = ['desc'], startAfter, limit) => this.subset(interfaces_1.Subset.MEMBERS)
            .getTopBySubColIdLive(member, orderBy, orderByDir, startAfter, limit)
            .pipe((0, rxjs_1.switchMap)(async (members) => {
            const promises = members.map((member) => this.id(member.parentId).get());
            return (await Promise.all(promises)).map((s) => s);
        }));
        this.getPendingSpacesByMemberLive = (member, orderBy = ['createdOn'], orderByDir = ['desc'], startAfter, limit) => this.subset(interfaces_1.Subset.KNOCKING_MEMBERS)
            .getTopBySubColIdLive(member, orderBy, orderByDir, startAfter, limit)
            .pipe((0, rxjs_1.switchMap)(async (members) => {
            const promises = members.map((member) => this.id(member.parentId).get());
            return (await Promise.all(promises)).map((s) => s);
        }));
    }
}
exports.SpaceDataset = SpaceDataset;
